import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== '/') {
      // If not on homepage, navigate to homepage first
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-brand" data-nav-url="https://prediedge.com/">
          <img src="/PrediEdge.png" alt="PrediEdge Logo" className="nav-logo" />
          <h1>PrediEdge</h1>
        </Link>
        <div className="nav-links">
          <button className="nav-link" onClick={() => scrollToSection('features')} data-nav-url="https://prediedge.com/#features">
            Features
          </button>
          {/* <Link to="/blog" className="nav-link" data-nav-url="https://prediedge.com/blog">
            Blog
          </Link>
          <Link to="/resources" className="nav-link" data-nav-url="https://prediedge.com/resources">
            Resources
          </Link>
          <Link to="/developers" className="nav-link" data-nav-url="https://prediedge.com/developers">
            For Developers
          </Link> */}
          <a 
            href="https://app.prediedge.com/?utm_source=site&utm_medium=navbar&utm_campaign=landing"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            data-nav-url="https://app.prediedge.com/?utm_source=site&utm_medium=navbar&utm_campaign=landing"
          >
            Launch App
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 